import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";

declare var ko: any;

export class transactionsSlipDetail_template extends vnTemplate {

    protected validationsList: validationsList_template;
    private printFrame: any = null;
    private printFrameUrl: string = "";
    private printFrameLoaded: boolean = false;

    protected getTemplateHtml(): string {

        return `
                    <div class="list-header w-justify" style="background: none;margin-bottom: 0">
                        <div class="w-left">
                            <button class="btn secondary icon i-back" data-bind="event: { click: onClickCancel }" id="confirm">Back to Payment</button>
                        </div>
                        <div class="w-right">
                            <button class="btn secondary icon i-file-pdf" data-bind="event: { click: onClickPrint }" id="confirm">PDF / Print</button>
                        </div>
                    </div>
                    
                    <div class="w-form w-form-large">

                    ` + this.validationsList.getHtmlBuild() + `
                    
                    
                    <div class="w-slip-list print-zone">
                    
                        <!-- ko if: showCompanyInvoiceTo() -->
                            <div class="split-label absolute" style="text-align: left">Invoice To:</div>
                        <!-- /ko -->
                        <div class="w-slip-header">
                            <div class="slip-header">
                                <div data-bind="class: 'slip-header-compagny full-icon ' + companyLogo()">
                                    <h4 data-bind="text: companyName"></h4>
                                    <address data-bind="html: companyAddress"></address>
                                    <!-- ko if: showCompanyExtraInfo() == true -->
                                        <br>
                                        <address data-bind="html: companyExtraInfo"></address>
                                    <!-- /ko -->
                                </div>
                                <div>
                                    <h5 data-bind="text: invoiceTitle"></h5>        
                                </div>
                            </div>
                            <div class="slip-header">
                                <div>
                                    <span class="split-label" data-bind="text: splitLabelText"></span>
                                    <h4 data-bind="text: userName"></h4>
                                    <address data-bind="text: paymentEmail, attr: { href: 'mailto:' + paymentEmail() }">
                                    </address>
                                </div>
                                <div>
                                    <dl>
                                        <dt data-bind="text: paymentDateText"></dt>
                                        <dd style="margin-bottom: 0;margin-top: 0.7rem;" data-bind="text: datePaid"></dd>
                                    </dl>
                                </div>
                                <!-- ko if: showInvoiceId() == true -->
                                <div>
                                    <dl>
                                        <dt>Invoice ID</dt>
                                        <dd style="margin-bottom: 0;margin-top: 0.7rem;" data-bind="text: invoiceId"></dd>
                                    </dl>
                                </div>
                                <!-- /ko -->
                                <div>
                                    <!-- ko if: showOtherTotals() == false -->
                                    <dl>
                                        <dt>Total</dt>
                                        <dd class="split-medium" data-bind="text: totalString() + ' ' + currency()"></dd>
                                    </dl>
                                    <!-- /ko -->
                                    
                                    <!-- ko if: showOtherTotals() == true -->
                                    <dl>
                                        <dt>Subtotal</dt>
                                        <dd class="split-medium" data-bind="text: subtotalString() + ' ' + currency()"></dd>
                                    </dl>
                                    <!-- ko foreach: salesTaxes -->
                                    <dl>
                                        <dt data-bind="text: label"></dt>
                                        <dd class="split-medium" data-bind="text: amount + ' ' + $parent.currency()"></dd>
                                    </dl>
                                    <!-- /ko -->
                                    <dl>
                                        <dt>Total</dt>
                                        <dd class="split-large" data-bind="text: totalString() + ' ' + currency()"></dd>
                                    </dl>
                                    <!-- /ko -->
                                </div>
                            </div>
                        </div>
                        <table class="slip-list">
                           
                            <tbody>
                                <!-- ko foreach: transactions -->

                                <tr class="section-primary">
                                    <td colspan="5">
                                        <span class="align-left full-icon" data-bind="text: name, css: icon"></span>
                                    </td>
     
                                    <td class="align-right">
                                        <span data-bind="text: $data.total"></span>
                                    </td>
                                </tr>
                                    <!-- ko foreach: $data.entries -->

                                    <tr class="section-secondary">
                                        <td style="width: 25px;"></td>
                                        <td style="line-height: 0;width: 65px;"><span class="valnet-task icon i-article-regular" data-bind="css: icon"></span></td>
                                        <td colspan="3"><span class="split-article-title" data-bind="text: item" ></span></td>
                                        <td class="align-right" data-bind="text: total"><span></span></td>
                                    </tr>
                                         <!-- ko foreach: $data.trxs -->

                                        <tr class="section-tertiary">
                                            <td colspan="2" style="85px"></td>

                                            <td><span class="icon no-wrap" data-bind="text: idTrx, css: icon"></span></td>
                                            <td><span data-bind="text: description"></span></td>
                                            <td><span class="icon no-wrap" data-bind="text: dateTransaction"></span></td>

                                            <td class="align-right"><span data-bind="text: amount"></span></td>
                                        </tr>
                                        <!-- ko if: showLineTaxes -->
                                        <!-- ko foreach: taxes -->
                                        <tr class="section-tertiary">
                                            <td colspan="2"></td>
                                            <td></td>
                                            <td><span data-bind="text: label"></span></td>
                                            <td></td>
                                            <td class="align-right"><span data-bind="text: amount"></span></td>
                                        </tr>
                                        <!-- /ko -->
                                        <tr class="section-tertiary">
                                            <td colspan="2"></td>
                                            <td></td>
                                            <td><span>Line total</span></td>
                                            <td></td>
                                            <td class="align-right"><span data-bind="text: lineTotal"></span></td>
                                        </tr>
                                        <!-- /ko -->
                                        <!-- /ko -->
                                        
                                        <!-- /ko -->
                                        <!-- /ko -->

                                
                            </tbody>
                        </table>
                    </div>
                    </div>
                    
                    <p data-bind="visible: total() < 0" class="slip-notice icon i-notice-alert">The balance will be transfer to the next payment.</p>
                `;
    }

    protected initPartial(): void {
        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this.caller);
    }

    protected getTemplateName(): string {
        return "transactionsSlipDetail-template";
    }

    protected getMainElementClasses(): Array<string> {
        return [""];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let self = this;
        return {
            paymentId: ko.observable(""),
            userId: ko.observable(""),
            transactions: ko.observableArray([]),
            total: ko.observable(''),
            totalString: ko.observable(''),
            subtotal: ko.observable(''),
            subtotalString: ko.observable(''),
            grandTotal: ko.observable(''),
            grandTotalString: ko.observable(''),
            balanceTransfer: ko.observable(''),
            userName: ko.observable(''),
            email: ko.observable(''),
            paymentEmail: ko.observable(''),
            country: ko.observable(''),
            currency: ko.observable(''),
            currencySymbol: ko.observable(''),
            datePaid: ko.observable(''),
            taxes: ko.observableArray([]),
            salesTaxes: ko.observableArray([]),
            companyName: ko.observable(''),
            companyAddress: ko.observable(''),
            companyExtraInfo: ko.observable(''),
            companyLogo: ko.observable(''),
            entryTypesTotal: ko.observableArray([]),
            sourceTab: ko.observable('payment'),
            splitLabelText: ko.observable('Invoice To'),
            paymentDateText: ko.observable('Payment Date'),
            showCompanyInvoiceTo: ko.observable(false),
            showCompanyExtraInfo: ko.observable(false),
            showOtherTotals: ko.observable(false),
            invoiceTitle: ko.observable('Invoice'),
            showInvoiceId: ko.observable(false),
            invoiceId: ko.observable(null),
            onClickCancel: function (data) {
                self.onClickCancel();
            },
            onClickPrint: (data) => {
                self.onClickPrint(data);
            }
        };
    }


    public setTransactions(transactions) {
        this.getTemplateViewModel().transactions(transactions);
    }

    public setEntryTypesTotal(entryTypes) {
        this.getTemplateViewModel().entryTypesTotal(entryTypes);
    }

    public setTaxes(taxes) {
        this.getTemplateViewModel().taxes(taxes);
    }

    public setCompany(company){

        this.getTemplateViewModel().companyName(company.name);
        this.getTemplateViewModel().companyAddress(company.address);
        this.getTemplateViewModel().companyLogo(company.logo);
    }

    public setTotal(total) {
        this.getTemplateViewModel().total(total);
    }

    public setPaymentId(paymentId) {
        this.getTemplateViewModel().paymentId(paymentId);
    }

    public setTotalString(totalString) {
        this.getTemplateViewModel().totalString(totalString);
    }

    public setSubtotal(subtotal) {
        this.getTemplateViewModel().subtotal(subtotal);
    }

    public setSubtotalString(subtotalString) {
        this.getTemplateViewModel().subtotalString(subtotalString);
    }

    public setSalesTaxes(salesTaxes) {
        this.getTemplateViewModel().salesTaxes(salesTaxes);
    }

    public setGrandTotal(grandTotal) {
        this.getTemplateViewModel().grandTotal(grandTotal);
    }

    public setGrandTotalString(grandTotalString) {
        this.getTemplateViewModel().grandTotalString(grandTotalString);
    }

    public setBalanceTransfer(balanceTransfer) {
        this.getTemplateViewModel().balanceTransfer(balanceTransfer);
    }

    public setUserInfo(data) {

        this.getTemplateViewModel().userName(data.user_fullName);
        this.getTemplateViewModel().email(data.email);
        this.getTemplateViewModel().paymentEmail(data.paymentEmail);
        this.getTemplateViewModel().country(data.country);
        this.getTemplateViewModel().currency(data.currency);
        this.getTemplateViewModel().currencySymbol(data.currencySymbol);
        this.getTemplateViewModel().datePaid(data.datePaid);
    }

    public onClickCancel() {
        this.caller.goBackToSlips();
    }

    public preloadPrintPdf(): void {

        this.preloadPdfUrl(this.buildSlipPdfUrl());
    }

    public onClickPrint(data): void {

        this.printPdfUrl(this.buildSlipPdfUrl());
    }

    private buildSlipPdfUrl(): string {

        let userId = this.getTemplateViewModel().userId();
        let datePaid = this.getDatePaidFromCurrentUrl();

        return window.location.origin + '/api/payment/documents/slip/' + userId + '/download/?datePaid=' + encodeURIComponent(datePaid) + '&inline=1';
    }

    private getDatePaidFromCurrentUrl(): string {

        let paramsString = window.location.href.split("?")[1] || "";
        for (let paramValue of paramsString.split("&")) {
            let datePaidParam = paramValue.split("=");

            if (datePaidParam[0] == "datePaid") {
                return decodeURIComponent(datePaidParam[1] || "");
            }
        }

        return this.getTemplateViewModel().datePaid();
    }

    private printPdfUrl(pdfUrl: string): void {

        if (!this.printFrame || this.printFrameUrl != pdfUrl) {
            this.preloadPdfUrl(pdfUrl);
        }

        let printFrame = this.printFrame;
        let printLoadedFrame = (delay: number) => {
            let printWindow = printFrame.contentWindow;

            if (!printWindow) {
                this.removePrintFrame(printFrame);
                return;
            }

            printWindow.onafterprint = () => this.removePrintFrame(printFrame);
            let printPdf = () => {
                printWindow.focus();
                printWindow.print();
            };

            if (delay > 0) {
                setTimeout(printPdf, delay);
            } else {
                printPdf();
            }

            setTimeout(() => this.removePrintFrame(printFrame), 60000);
        };

        if (this.printFrameLoaded) {
            printLoadedFrame(0);
            return;
        }

        printFrame.onload = () => {
            this.printFrameLoaded = true;
            printLoadedFrame(30);
        };
    }

    private preloadPdfUrl(pdfUrl: string): void {

        if (this.printFrame && this.printFrameUrl == pdfUrl) {
            return;
        }

        this.removePrintFrame(this.printFrame);

        let printFrame = document.createElement('iframe');
        printFrame.style.position = 'fixed';
        printFrame.style.right = '0';
        printFrame.style.bottom = '0';
        printFrame.style.width = '0';
        printFrame.style.height = '0';
        printFrame.style.border = '0';

        printFrame.onload = () => {
            this.printFrameLoaded = true;
        };

        this.printFrame = printFrame;
        this.printFrameUrl = pdfUrl;
        this.printFrameLoaded = false;
        document.body.appendChild(printFrame);
        printFrame.src = pdfUrl;
    }

    private removePrintFrame(printFrame: any): void {

        if (printFrame && printFrame.parentNode) {
            printFrame.parentNode.removeChild(printFrame);
        }

        if (this.printFrame == printFrame) {
            this.printFrame = null;
            this.printFrameUrl = "";
            this.printFrameLoaded = false;
        }
    }

    public getSourceTab(): string {
        return this.getTemplateViewModel().sourceTab();
    }

    setCompanyExtraInfo(value): void {
        this.getTemplateViewModel().companyExtraInfo(value);
    }
    setSplitLabelText(value): void {
        this.getTemplateViewModel().splitLabelText(value);
    }
    setPaymentDateText(value): void {
        this.getTemplateViewModel().paymentDateText(value);
    }
    setShowCompanyInvoiceTo(value): void {
        this.getTemplateViewModel().showCompanyInvoiceTo(value);
    }
    setShowCompanyExtraInfo(value): void {
        this.getTemplateViewModel().showCompanyExtraInfo(value);
    }

    setUserName(value): void {
        this.getTemplateViewModel().userName(value);
    }

    setShowOtherTotals(value) {
        this.getTemplateViewModel().showOtherTotals(value);
    }

    setShowInvoiceId(value) {
        this.getTemplateViewModel().showInvoiceId(value);
    }

    setInvoiceId(value): void {
        this.getTemplateViewModel().invoiceId(value)
    }

    setInvoiceTitle(value) {
        this.getTemplateViewModel().invoiceTitle(value);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/transactionsSlipDetail_template.ts